import BaseEntityService from './BaseEntityService';
import axiosInstance from '../../services/api';

export class TreatmentService extends BaseEntityService {
  static baseUrl = '/api/treatments';

  static async filterTreatments(params = {}) {
    return super.filterEntities(this.baseUrl, params);
  }

  static async getTreatment(identifier) {
    return super.getEntity(
      this.baseUrl, 
      identifier, 
      '?include_products=true&include_health=true&include_environment=true&include_treatment_enemies=true&include_treatment_cultures=true'
    );
  }

  static async getCultureTree(treatmentId, params = {}) {
    try {
      const { data } = await axiosInstance.get(
        `/api/cultures/treatments/${treatmentId}/culture-tree/`,
        { params }
      );
      return data;
    } catch (error) {
      console.error('Error fetching culture tree:', error);
      throw error;
    }
  }

  static async getTreatmentCultureTree(treatmentId, params = {}) {
    try {
      const { data } = await axiosInstance.get(
        `${this.baseUrl}/${treatmentId}/culture-tree/`,
        { params }
      );
      return data;
    } catch (error) {
      console.error('Error fetching treatment culture tree:', error);
      throw error;
    }
  }
}

export const treatmentKeys = {
  all: ['treatments'],
  filters: () => [...treatmentKeys.all, 'filter'],
  filter: (params) => [...treatmentKeys.filters(), params],
  details: () => [...treatmentKeys.all, 'detail'],
  detail: (id) => [...treatmentKeys.details(), id],
  cultureTree: (id, params) => [
    ...treatmentKeys.detail(id),
    'cultureTree',
    params,
  ],
};